<div class="scorecard-sub-nav position-relative">
  <div class="sn-indicator" #indicator></div>
  <button
    class="tab-btn"
    #tabBtn
    [class.active]="activeTab === 'active'"
    (click)="selectTab('active')"
    type="button"
  >
    Active
  </button>
  <button
    class="tab-btn"
    #tabBtn
    [class.active]="activeTab === 'completed'"
    (click)="selectTab('completed')"
    type="button"
  >
    Completed
  </button>
</div>
